import { useGetUserInstallInfosSuspenseQuery } from '../../../__generated__/chirp/com/hubspot/application/installs/rpc/ApplicationInstallsRpc.hooks';
import { useApp } from '../../contexts/AppContext';
import { useCaptureError } from '../useCaptureError';
export function useFetchInstalledUsers() {
  const {
    appId
  } = useApp();
  const {
    error,
    data
  } = useGetUserInstallInfosSuspenseQuery({
    variables: {
      appId
    }
  });
  useCaptureError(error, {
    message: 'Error fetching installed users'
  });
  return {
    error,
    data
  };
}